import { ChangeEvent } from 'react'

import { Label } from 'shared/atoms'
import { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type ColorPickerProps = WithClassName<{
	id?: string
	label: string
	color: string
	onChange: (data: { hex: string }) => void
}>

const HEX_COLOR_PATTERN = /^#[0-9a-f]{6}$/i
const FALLBACK_COLOR = '#000000'

export const ColorPicker = ({ id, label, color, className, onChange }: ColorPickerProps) => {
	const swatchColor = HEX_COLOR_PATTERN.test(color) ? color : FALLBACK_COLOR

	const handleChange = (event: ChangeEvent<HTMLInputElement>) =>
		onChange({ hex: event.target.value })

	return (
		<div className={cn('flex flex-col gap-y-1.5', className)}>
			<Label htmlFor={id} text={label} />
			<div className="flex h-10 items-center gap-2 rounded-md border border-border bg-card px-2 transition focus-within:border-primary focus-within:ring-2 focus-within:ring-primary/20">
				<input
					id={id}
					type="color"
					aria-label={label}
					value={swatchColor}
					onChange={handleChange}
					className="h-7 w-7 shrink-0 cursor-pointer rounded-full border border-border bg-transparent p-0 [&::-moz-color-swatch]:rounded-full [&::-moz-color-swatch]:border-none [&::-webkit-color-swatch-wrapper]:p-0 [&::-webkit-color-swatch]:rounded-full [&::-webkit-color-swatch]:border-none"
				/>
				<input
					type="text"
					aria-label={label}
					value={color}
					maxLength={7}
					spellCheck={false}
					onChange={handleChange}
					className="min-w-0 flex-1 bg-transparent text-[13px] text-foreground outline-none"
				/>
			</div>
		</div>
	)
}
